import React, { Component } from 'react'
import { Icon, Select, Button } from '@driftt/tide-core-legacy'
import AddButton from 'components/Integration/components/AddButton/index'
import withNotifications from 'components/shared/notifications'
import { api } from 'app/modules/sfdc/api'

import './style.styl'

const ALLOWED_TYPES = Object.freeze(["STRING", "NUMERIC", "DATE", "DATETIME"])

const conversationMetrics = { 'Agent average response time': "Duration",
'Agent max response time': "Duration",
'Agent message count': "Integer",
'End time': "Date Time",
'Request time': "Date Time",
'Response time': "Duration",
'Start time': "Date Time",
'Time to close': "Duration",
'Visitor average response time': "Duration",
'Visitor max response time': "Duration",
'Visitor message count': "Integer",
'Conversation Id': "Integer"
}

class SalesforceMetricsMapping extends Component {

  constructor(props) {
    super(props)

    this.state = {
      mappings: _.cloneDeep(props.sfdcMetricMappings),
      sfdcTaskFields: [],
      isLoading: true
    }
  }

  componentDidUpdate(prevProps) {
    const { sfdcMetricMappings, sfdcPatchMetricsErr } = this.props
    if (!_.isEqual(prevProps.sfdcMetricMappings, sfdcMetricMappings)){
      this.setState({
        mappings: _.cloneDeep(sfdcMetricMappings)
      })
    }

    if (sfdcPatchMetricsErr) {
      sfdcPatchMetricsErr.json().then(resp => {
        resp.message && this.props.notifications.error(resp.message)
      })
    }
  }

  componentDidMount = async () => {
    try {
      const fetchedProps = await api.fetchSFDCTaskProperties()
      this.setState({
        sfdcTaskFields: fetchedProps.properties,
        isLoading: false
      })
    } catch (e) {
      console.error(e)
      this.props.notifications.error("Failed to retrieve SFDC Task Fields. If this problem persists, chat in")
      this.setState({
        isLoading: false
      })
    }
    this.props.actions.fetchSFDCMetricsMappings()
    if (!this.state.mappings.length) {
      this.addNewMapping()
    }
  }

  getSalesforceTaskFieldOptions(fieldName) {
    const mappedFields = this.state.mappings
      .map(mapping => mapping.integrationAttribute)
      .filter(name => name !== fieldName)
    if(!fieldName){
      const unMappedFields = this.state.mappings
        .filter(mapping => mapping.driftAttribute && !mapping.integrationAttribute)
        .map(mapping => mapping.driftAttribute)
      if(unMappedFields[0]){
        return this.state.sfdcTaskFields.filter(mapping => this.checkType(conversationMetrics[unMappedFields[0]], mapping.type)).map(mapping =>{
          return { label: mapping.displayName, value: mapping.name }
        })
      }
    }
    
    return this.state.sfdcTaskFields
      .filter(mapping => !mappedFields.includes(mapping.name) && ALLOWED_TYPES.includes(mapping.type))
      .map(mapping => {
        return { label: mapping.displayName, value: mapping.name }
      })
  }

  getFormattedMetricOptions() {
    return Object.keys(conversationMetrics).map(metric => {
      return { value: metric, label: metric }
    })
  }

  addNewMapping = () => {
    this.setState(prevState => (
      {
        mappings: [...prevState.mappings, {}]
      }
    ))
  }

  removeMapping = (index) => {
    this.setState(prevState => {
      const updatedMappings = [...prevState.mappings]
      updatedMappings.splice(index, 1)

      return { mappings: updatedMappings }
    })
  }

  saveSalesforceOption(value, index) {
    this.setState(prevState => {
      const newMappings = [...prevState.mappings]
      newMappings[index].integrationAttribute = value ? value.value : null
      return { newMappings }
    })
  }

  saveDriftMetricOption(value, index) {
    this.setState(prevState => {
      const newMappings = [...prevState.mappings]
      newMappings[index].driftAttribute = value ? value.value : null
      return { newMappings }
    })
  }

  renderSalesforceDropdown(value, index) {
    const selectOptions = {
      placeholder: "Select Salesforce task field..",
      value: value,
      options: this.getSalesforceTaskFieldOptions(value),
      searchable: true,
      clearable: false,
      pageSize: 10,
      onChange: value => this.saveSalesforceOption(value, index),
    }

    return (
      <Select {...selectOptions} />
    )
  }

  renderDriftMetricDropdown(id, index) {
    const selectOptions = {
      value: id,
      pageSize: 10,
      searchable: true,
      clearable: false,
      placeholder: "Select conversation metric..",
      options: this.getFormattedMetricOptions(),
      onChange: value => this.saveDriftMetricOption(value, index),
    }

    return (
      <Select {...selectOptions} />
    )
  }

  renderMappingRows() {
    return this.state.mappings.map((mapping, index) => {
      return (
        <tr key={index}>
          <td>{this.renderDriftMetricDropdown(mapping.driftAttribute || mapping.defaultValue, index)}</td>
          <td className="salesforce-metric-mapping-table-separator"></td>
          <td className="salesforce-metric-mapping-table-separator-type">{conversationMetrics[mapping.driftAttribute]}</td>
          <td className="salesforce-metric-mapping-table-separator"></td>
          <td>{this.renderSalesforceDropdown(mapping.integrationAttribute, index)}</td>
            <td className="salesforce-metric-mapping-actions">
              <span onClick={() => this.removeMapping(index)}>
                <Icon width={15} name="close"/>
              </span>
            </td>
        </tr>
      )
    })
  }

  checkType(driftType, salesforceType) {
    if (driftType === "Date Time" && (salesforceType==="DATE" || salesforceType=== "DATETIME" || salesforceType === "STRING")) {
      return true;
    }
    if (driftType === "Duration" && salesforceType === "STRING") {
      return true
    }
    if (driftType === "Integer" && (salesforceType === "NUMERIC" || salesforceType === "STRING")) {
      return true
    }
    // Returns whether the drift type is compatible with the salesforce type.
    return false;

  }

  isMappingTypeConsistent(mapping) {
    const { notifications } = this.props
    const { sfdcTaskFields } = this.state
    const field = sfdcTaskFields.filter(field => field.name === mapping.integrationAttribute)[0]
    if (!field) {
      notifications.error("The Salesforce task field " + mapping.integrationAttribute + " was not found in your Salesforce instance. Remove the blank mapping below for task attachment to succeed")
      return true
    }
    if (field.type && this.checkType(conversationMetrics[mapping.driftAttribute], field.type)){
      return true
    }
    notifications.error( "Metric " + mapping.driftAttribute + "'s type, " + conversationMetrics[mapping.driftAttribute] + ", cannot be mapped to " + field.displayName + "'s type, "+field.type)
    mapping.integrationAttribute = null
    return false
  }
  
  isClean = () => {
    if (!this.state.isLoading && !!this.state.sfdcTaskFields.length && this.state.sfdcTaskFields.length === 0){
      notifications.error("Failed to retrieve task fields from Salesforce. This is likely due to a lack of read permissions on task fields.")
    }

    const validMappings = this.getValidMappings()
    return _.isEqual(validMappings, this.props.sfdcMetricMappings)
  }

  isMappingValid(mapping) {
    return !_.isEmpty(mapping) &&
          (!!mapping.driftAttribute || !!mapping.defaultValue) && 
          !!mapping.integrationAttribute &&
          this.isMappingTypeConsistent(mapping)
  }

  getValidMappings = () => {
    return _.filter(this.state.mappings, (map) => {
      return this.isMappingValid(map)
    })
  }

  saveUpdatedMappings = () => {
    if(!this.isClean()) {
      const { notifications } = this.props
      this.props.actions.patchSFDCMetricsMappings(this.getValidMappings(), () => notifications.success("You successfully updated your Salesforce App!"))
    }
  }

  render() {
    const { sfdcPatchMetricsLoading } = this.props
    if(this.state.isLoading){
      return null
    }
    return (
      <div>
        <div className="mapping-actions">
          <Button
                onClick={this.saveUpdatedMappings}
                size="medium"
                loading={sfdcPatchMetricsLoading}
                disabled={this.isClean()}
              >
                Update
              </Button>
        </div>
        <div className="salesforce-metric-mapping">
          <table className="drift-table">
            <thead>
              <tr>
                <td>Conversation Metric</td>
                <td className="salesforce-metric-mapping-table-separator"></td>
                <td>type</td>
                <td className="salesforce-metric-mapping-table-separator"></td>
                <td>Salesforce Attribute</td>
                <td className="salesforce-metric-mapping-actions"></td>
              </tr>
            </thead>
            <tbody>
              {this.renderMappingRows()}
            </tbody>
          </table>
          <AddButton
            addButtonLabel="Map New Conversation Metric"
            type="tertiary"
            onClick={this.addNewMapping}
          />
        </div>
      </div>
    )
  }
}

export default withNotifications(SalesforceMetricsMapping)



// WEBPACK FOOTER //
// ./src/scripts/components/SFDC/MetricsMapping/index.js